var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.curTitle,
        visible: _vm.visible,
        width: "710px",
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c("div", { staticClass: "y-f" }, [
        _c("i", { staticClass: "el-icon-warning y-fs-18 y-fc-E6A23C y-mr-5" }),
        _c(
          "div",
          [
            _c("div", { staticClass: "y-fs-16 y-fc-333 y-fw-700" }, [
              _vm._v(
                "确认是否" +
                  _vm._s(_vm.titleType === "1" ? "订购" : "授权") +
                  "当前登录的店铺？"
              ),
            ]),
            _c("div", { staticClass: "y-fs-14 y-mt-10" }, [
              _vm._v(
                "若出现店铺无法" +
                  _vm._s(_vm.titleType === "1" ? "订购" : "授权") +
                  "，请按照以下步骤尝试解决："
              ),
            ]),
            _c(
              "div",
              { staticClass: "y-mt-10 y-fs-14" },
              [
                _vm._v(" 1、点击打开"),
                _c("svg-icon", {
                  staticClass: "icon",
                  attrs: { iconClass: _vm.PLATFORMICONMAP[_vm.platFormCode] },
                }),
                _c(
                  "a",
                  {
                    staticClass: "y-fc-4C84FF y-a-none",
                    attrs: {
                      href: _vm.linkMap[_vm.platFormCode],
                      target: "_blank",
                    },
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.PLATFORMNAMEMAP[_vm.platFormCode]) + "商家后台"
                    ),
                  ]
                ),
              ],
              1
            ),
            _c("div", { staticClass: "y-mt-10 y-fs-14" }, [
              _vm._v(
                "2、查看右上角店铺名称是否是需要" +
                  _vm._s(_vm.titleType === "1" ? "订购" : "授权") +
                  "的店铺"
              ),
            ]),
            _c("div", { staticClass: "y-mt-10 y-fs-14" }, [
              _vm._v(
                "3、若需要" +
                  _vm._s(_vm.titleType === "1" ? "订购" : "授权") +
                  "新店铺，请先退出店铺后再进行" +
                  _vm._s(_vm.titleType === "1" ? "订购" : "授权")
              ),
            ]),
            _vm.imgMap[_vm.platFormCode]
              ? _c("el-image", {
                  staticClass: "y-w-400 y-mt-10",
                  attrs: {
                    src: _vm.imgMap[_vm.platFormCode],
                    "preview-src-list": [_vm.imgMap[_vm.platFormCode]],
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
      _c(
        "el-checkbox",
        {
          staticClass: "y-mt-10",
          model: {
            value: _vm.checked,
            callback: function ($$v) {
              _vm.checked = $$v
            },
            expression: "checked",
          },
        },
        [_vm._v("下次不再提醒")]
      ),
      _c(
        "div",
        { staticClass: "y-t-ac", attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleConfirm } },
            [_vm._v("确认" + _vm._s(_vm.titleType === "1" ? "订购" : "授权"))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }